import React, { useState, useEffect, useContext } from 'react';

import moment from 'moment';

import { PacksDispatchContext, PacksContext } from '../ApiProvider';
import { AssignContext, AssignDispatchContext } from '../AssignProvider';

import { saveAssigns } from 'Helpers/costPacks';

import Button from 'CommonComponents/Button';
import NumberFormat from 'CommonComponents/LocalisedNumberFormat';

function PackToVenueForm({ packId, venueId, filterDay, filterDays, formattedDate, formattedDates, selectedSchedules }) {
    const [details, setDetails] = useState({
        packId: false,
        venueId: false,
        packName: '',
        venueName: '',
        formattedDate: '',
        amount: 0,
        filterDay: '',
    });
    const [initialDetails, setInitialDetails] = useState(null);
    const [checked, setChecked] = useState(false);
    const [includeDatesWithoutSession, setIncludeDatesWithoutSession] = useState(false);
    const [durationNotDefined, setDurationNotDefined] = useState(false);
    const [startTime, setStartTime] = useState('');
    const [packChildren, setPackChildren] = useState([]);
    const [endTime, setEndTime] = useState('');
    const [pack, setPack] = useState(null);
    const [contractorPack, setContractorPack] = useState('');
    const { packs, venues } = useContext(PacksContext);
    const { filteredPacks, selectedAmount } = useContext(AssignContext);
    const assignAction = useContext(AssignDispatchContext);
    const apiCall = useContext(PacksDispatchContext);
    const assigned = filteredPacks.find((p) => p.packId == packId);

    useEffect(() => {
        if (packId) {
            const thisPack = packs.find((p) => p.id == packId);
            const thisVenue = venues.find((v) => v.id == venueId);
            const amount = assigned && Object.prototype.hasOwnProperty.call(assigned, 'amount') ? assigned.amount : 0;
            const details = assigned && Object.prototype.hasOwnProperty.call(assigned, 'details') ? assigned.details : [];
            const detailsObj = {
                packId: packId,
                venueId: venueId,
                packName: thisPack.name,
                venueName: thisVenue.name,
                formattedDate: formattedDate,
                formattedDates: formattedDates,
                filterDay: filterDay,
                filterDays: filterDays,
                packContractorTotal: 0,
                amount: amount,
                details: details,
                packContractor: thisPack.pack_contractor,
            };
            setPack(thisPack);
            setStartTime(details && 'start' in details ? moment(details['start']).format('HH:mm') : '');
            setEndTime(details && 'end' in details ? moment(details['end']).format('HH:mm') : '');
            setContractorPack(thisPack.pack_contractor);
            setPackChildren(thisPack.pack_children);
            setDetails(detailsObj);
            setInitialDetails(detailsObj);
            if (assigned) {
                if (!details) {
                    setChecked(false);
                } else if (details.duration === 0) {
                    setChecked(false);
                } else if (details.useSessionTime) {
                    setChecked('start' in details && details.start);
                } else if (!details.useSessionTime) {
                    setChecked(false);
                } else {
                    setChecked(true);
                }
            }
        }
    }, [filteredPacks, formattedDate, formattedDates]);

    useEffect(() => {
        if (!assigned) {
            if (_.isArray(selectedSchedules)) {
                setChecked(!!(selectedSchedules.length > 0 && selectedSchedules[0].start));
            } else {
                setChecked(!!(selectedSchedules && selectedSchedules.start));
            }
        }
        let selectedSchedulesDates = selectedSchedules.map((schedule) => schedule.date);
        if (selectedSchedulesDates.length !== filterDays.length) {
            setIncludeDatesWithoutSession(true);
        } else {
            setIncludeDatesWithoutSession(false);
        }
    }, [selectedSchedules]);

    const handleAmountChange = (values) => {
        // If pack can be edited and commitment exists, only allow increasing the amount
        if (pack?.can_be_edited && pack?.commitment_exists && values.value < initialDetails.amount) {
            return; // Prevent decreasing the amount
        }

        setDetails({ ...details, amount: values.value });
    };

    const handleDelete = () => {
        apiCall('packToVenueDelete', details);
        saveAssigns();
    };

    const defaultArray = () => {
        return [
            {
                name: 'Quantity shift 1',
                hours: 0,
                total: 0,
            },
        ];
    };

    const handleSubmit = () => {
        setDurationNotDefined(false);

        let array = defaultArray();
        let manualArray = defaultArray();

        let duration = 0;
        let noSessionDuration = 0;
        let packScheduleStart = undefined;
        let packScheduleEnd = undefined;
        let hasManualTime = false;

        const det = { ...details };
        det.selectedSchedules = selectedSchedules;
        det.checked = checked;

        if (det.packContractor) {
            if (startTime && endTime) {
                packScheduleStart = moment(details.filterDay + ' ' + startTime);
                packScheduleEnd = moment(details.filterDay + ' ' + endTime);
                hasManualTime = true;
                const manualDuration = moment.duration(packScheduleEnd.diff(packScheduleStart));
                noSessionDuration = Math.round(manualDuration.asHours() * 100) / 100;
            }

            if (checked) {
                if (_.isArray(selectedSchedules)) {
                    duration = selectedSchedules.length > 0 ? timeToFloat(selectedSchedules[0].duration) : 0;
                } else {
                    duration = timeToFloat(selectedSchedules.duration);
                }
            }

            if (duration === 0 && startTime && endTime && packScheduleStart && packScheduleEnd) {
                duration = timeToFloat(moment.utc(packScheduleEnd.diff(packScheduleStart)).format('HH:mm'));
            }

            if (duration === 0) {
                setDurationNotDefined(true);
                return;
            }
        }
        packChildren.forEach((item) => {
            if (selectedSchedules && item.pack_contractor) {
                let total = 0;
                let manual_total = 0;
                let contractor_duration = duration + item.start_time_before + item.finish_time_after;
                let manual_contractor_duration = hasManualTime ? noSessionDuration + item.start_time_before + item.finish_time_after : contractor_duration;

                if (contractor_duration > item.max_shift_duration) {
                    array = findShifts(contractor_duration, item.price, item.max_shift_duration, item.min_shift_duration, item.shift_overlap);
                    for (let i = 0; i < array.length; i++) {
                        total += array[i]['total'];
                    }
                } else {
                    if (contractor_duration < item.min_shift_duration) {
                        total = item.price * item.min_shift_duration;
                    } else if (contractor_duration <= item.max_shift_duration && contractor_duration >= item.min_shift_duration) {
                        total = contractor_duration.toFixed(1) * item.price;
                    }

                    array[0].hours = contractor_duration;
                    array[0].total = total;
                }

                if (hasManualTime) {
                    if (manual_contractor_duration > item.max_shift_duration) {
                        manualArray = findShifts(manual_contractor_duration, item.price, item.max_shift_duration, item.min_shift_duration, item.shift_overlap);
                        for (let i = 0; i < manualArray.length; i++) {
                            manual_total += manualArray[i]['total'];
                        }
                    } else {
                        if (manual_contractor_duration < item.min_shift_duration) {
                            manual_total = item.price * item.min_shift_duration;
                        } else if (manual_contractor_duration <= item.max_shift_duration && manual_contractor_duration >= item.min_shift_duration) {
                            manual_total = manual_contractor_duration.toFixed(1) * item.price;
                        }

                        manualArray[0].hours = manual_contractor_duration;
                        manualArray[0].total = total;
                    }
                } else {
                    manualArray = JSON.parse(JSON.stringify(array));
                }
            }
        });
        let durationJson = {
            duration,
            useSessionTime: checked,
            start: packScheduleStart,
            end: packScheduleEnd,
        };

        let manualDurationJson = {
            duration: noSessionDuration,
            useSessionTime: checked,
            start: packScheduleStart,
            end: packScheduleEnd,
        };

        const durationObject = {
            manual: manualDurationJson,
            default: durationJson,
        };

        det.details.useSessionTime = checked;
        apiCall('packToVenueEdit', det, durationObject);
        saveAssigns();
    };

    const handleChange = (value) => {
        setChecked(value);
    };

    return (
        <div>
            <div>
                <div className="tw-flex tw-flex-col tw-space-y-1.5">
                    <label className="tw-mt-1 text-input__label" htmlFor="amount">
                        {$t('Amount')}
                    </label>
                    <NumberFormat
                        disabled={contractorPack}
                        value={contractorPack ? 1 : details.amount}
                        className="form-control form-control-sm"
                        decimalScale={10}
                        thousandSeparator={true}
                        inputMode="numeric"
                        allowNegative={false}
                        onValueChange={(values) => {
                            handleAmountChange(values);
                        }}
                    />
                </div>

                <div className="form-group mt-2">
                    {!!details.packContractor && (!checked || includeDatesWithoutSession) && (
                        <>
                            <div className="row no-gutters align-items-center mt-2">
                                <div className="col-3">
                                    <label htmlFor="specific" className="form-check-label">
                                        Start time
                                    </label>
                                </div>

                                <div className="col-9">
                                    <input
                                        value={startTime}
                                        onChange={(e) => setStartTime(e.target.value)}
                                        type="time"
                                        className="form-control form-control-sm"
                                    />
                                </div>
                            </div>

                            <div className="row no-gutters align-items-center mt-2">
                                <div className="col-3">
                                    <label htmlFor="specific" className="form-check-label">
                                        End time
                                    </label>
                                </div>

                                <div className="col-9">
                                    <input value={endTime} onChange={(e) => setEndTime(e.target.value)} type="time" className="form-control form-control-sm" />
                                </div>
                            </div>
                        </>
                    )}
                </div>

                {!!details.packContractor && selectedSchedules.length > 0 && selectedSchedules[0].start && (
                    <>
                        <div className="row no-gutters align-items-center mt-2">
                            <div className="col-auto mr-2">
                                <div className="toggl-input">
                                    <input
                                        checked={checked}
                                        id="specific"
                                        className="toggl-input-checkbox"
                                        name="specific"
                                        type="checkbox"
                                        value="1"
                                        onChange={(e) => handleChange(e.target.checked)}
                                    />
                                    <label htmlFor="specific" className="toggl-input-label mb-0" />
                                </div>
                            </div>

                            <div className="col">
                                <label htmlFor="specific" className="form-check-label">
                                    Use session time
                                </label>
                            </div>
                        </div>
                    </>
                )}
                {durationNotDefined && (
                    <div>
                        <label className="text-danger">Duration can&apos;t be 0</label>
                    </div>
                )}
            </div>
            <div className="modal__footer">
                <Button variant="secondary" onClick={() => apiCall('form', false)}>
                    {$t('Cancel')}
                </Button>
                {details.amount > 0 && (
                    <Button
                        variant="danger"
                        className={pack?.commitment_exists ? 'tw-opacity-50 tw-cursor-not-allowed' : ''}
                        onClick={() => {
                            if (pack?.commitment_exists) {
                                alert('You must delete the committed item attached to this cost pack allocation before it can be deleted');
                                return;
                            }
                            handleDelete();
                        }}
                    >
                        {$t('Delete')}
                    </Button>
                )}
                <Button variant="primary" onClick={() => handleSubmit()}>
                    {$t('Update')}
                </Button>
            </div>
        </div>
    );
}

const timeToFloat = (time) => {
    const hoursMinutes = time.toString().split(':');
    const hours = parseInt(hoursMinutes[0], 10);
    const minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0;
    return hours + minutes / 60;
};

const findShifts = (duration, price, max_shift_duration, min_shift_duration, shift_overlap, shifts = 0, array = []) => {
    if (max_shift_duration === 0) {
        return array;
    }

    shifts++;
    if (duration > max_shift_duration) {
        let value = 0;
        let total = 0;
        if (shifts === 1) {
            duration -= max_shift_duration;
            value = max_shift_duration;
            total += price * max_shift_duration;
        } else {
            duration -= max_shift_duration + shift_overlap;
            value = max_shift_duration + shift_overlap;
            total += price * (max_shift_duration + shift_overlap);
        }

        array.push({ name: `Quantity shift ${shifts}`, hours: value, total: total });
        findShifts(duration, price, max_shift_duration, min_shift_duration, shift_overlap, shifts, array);
    } else if (duration <= max_shift_duration && duration >= min_shift_duration) {
        array.push({
            name: `Quantity shift ${shifts}`,
            hours: min_shift_duration + shift_overlap,
            total: price * (min_shift_duration + shift_overlap),
        });
    } else {
        array.push({
            name: `Quantity shift ${shifts}`,
            hours: min_shift_duration + shift_overlap,
            total: price * (min_shift_duration + shift_overlap),
        });
    }
    return array;
};
export default PackToVenueForm;
